import axios from "axios";
import { toast } from "sonner";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Auth is carried entirely by the HttpOnly `session_token` cookie the backend
// sets on login/register/google (sent automatically via withCredentials).
// We deliberately do NOT read any token from localStorage or attach an
// Authorization header — keeping the session token out of JS-readable storage
// removes the XSS token-theft surface.

// Global 401 handler — session expired or cookie no longer valid.
// Redirect the user back to /login exactly once, preserving where they were
// so we can send them back there after they sign in again.
let sessionExpireHandled = false;
const AUTH_ENDPOINTS_NO_REDIRECT = [
  "/auth/me",
  "/auth/login",
  "/auth/register",
  "/auth/logout",
  "/auth/forgot-password",
  "/auth/reset-password",
  "/auth/verify-email",
  "/auth/google/session",
];

api.interceptors.response.use(
  (r) => r,
  (err) => {
    const status = err?.response?.status;
    const url = err?.config?.url || "";
    const skipRedirect = AUTH_ENDPOINTS_NO_REDIRECT.some((p) => url.includes(p));
    if (status === 401 && !skipRedirect && !sessionExpireHandled) {
      sessionExpireHandled = true;
      const path = window.location.pathname || "/";
      const search = window.location.search || "";
      const onLogin = path.startsWith("/login") || path.startsWith("/register");
      if (!onLogin) {
        const returnTo = encodeURIComponent(path + search);
        toast.error("Your session has expired. Please sign in again.");
        setTimeout(() => {
          window.location.href = `/login?return_to=${returnTo}`;
        }, 900);
      }
    }
    return Promise.reject(err);
  }
);

// Called by AuthContext after a successful login/register/logout. The cookie
// is the single source of truth now, so this only re-arms the 401 redirect
// handler on a fresh login — it stores nothing in the browser.
export const setToken = (t) => {
  if (t) sessionExpireHandled = false;
};

export default api;
